module.exports = "/assets/860f907da598941d78f9ca800761ed0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/cars/assets/logos/unknown.jpg
// module id = 772
// module chunks = 0